// @flow
import { isBlank } from "voca";
import appConfig from "appConfig";
import { getLogger } from "common/logger";
import { api } from "services";

type apiOptions = { apiKey: string };

type queryOptions = {
    query: string,
    type?: string,
    start?: number,
    searchRight?: string,
    searchSite?: string,
    images?: Object[]
};

type searchResultsType = {
    error?: Object,
    images: Object[],
    queries?: Object[],
    info?: Object,
};

const logger = getLogger();

const getImagesFromSearchResult = (res, options: queryOptions) => {
	const items = (res.items)
		? res.items.map((item) => ({
			key: item.link,
			id: item.link,
			thumbnail: item.link,
			url: item.link,
			link: item.link,
			title: `${item.image.width} × ${item.image.height}`,
			subtitle: item.title,
			selected: item.selected,
		})) : [];

	const isInfinite = res.queries && res.queries.request[0].startIndex !== 1;

	return isInfinite && options.images
		? options.images.concat(items)
		: items || [];
};

const getSearchParams = (apiKey, query: queryOptions) => ({
	q: query.query,
	cx: appConfig.google.cx,
	key: apiKey,
	num: appConfig.google.searchItemsLimit,
	searchType: query.type || "image",
	start: query.start || 1,
	rights: query.searchRight,
	siteSearch: (query.searchSite !== "all" ? query.searchSite : ""),
	siteSearchFilter: "i",
});

export default (options: apiOptions) => {
	const { apiKey } = options;

	logger.log(`[googleService]: creating google api client with api key = ${apiKey.substr(-4)}`);

	const doSearch = async (query: queryOptions): Promise<searchResultsType> => {
		const result: searchResultsType = { images: [] };

		if (!isBlank(query.query)) {
			const searchUrl = `${appConfig.google.searchBase}${appConfig.google.searchPath}`;
			const params = getSearchParams(apiKey, query);

			try {
				const apiResult = await api.get(searchUrl, params);

				result.images = getImagesFromSearchResult(apiResult, query);
				result.info = apiResult.searchInformation;
				result.queries = apiResult.queries;
			} catch (err) {
				logger.warn(`[googleService.search]: encountered error when doing search for: ${query.query}`, err);
				result.error = err;
			}
		}

		return result;
	};

	return {
		doSearch,
	};
};
